<template>
    <card class="content business">
        <span slot="title">
            交易信息
        </span>

        <el-link 
        slot="title-r"
        :underline="false" 
        type="primary"
        href="/business"
        >
            查看更多>
        </el-link>

        <div class="search">
            <div class="label">搜索公告：</div>
            <div class="con">
                <el-input 
                    v-model="searchText" 
                    class="input-search" 
                    size="middle" 
                    placeholder="请输入公告名称" >
                        <el-button 
                            slot="append" 
                            @click="searchHandler">
                                <i class="el-icon-search" style="font-size:20px"></i>
                        </el-button>
                </el-input>
            </div>
        </div>

        <!-- <search-bar
            v-model="pgData"
            @change="queryData"
        ></search-bar> -->

        <div class="search-bar">
            <div class="search-item">
                <div class="label">招标内容：</div>

                <div class="list">
                    <div 
                    class="item" 
                    v-for="(item, index) in ggType"
                    :class="[item.type===pgData.type ? 'active' : '']" 
                    @click="updateModel('type', item.type)"
                    :key="index"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
        </div>

        <el-divider
            class="divider"
        ></el-divider>

        <list
        :data="tableData"
        :props="{title:'GGNAME', time:'GGFBTIME'}"
        :href="hrefBuilder"
        >
            <div slot-scope="scope">
                【{{scope.row.TYPENAME}}】
                【{{scope.row.CITYNAME}}】
                {{scope.row.GGNAME}}
            </div>
        </list>
    </card>
</template>

<script>
import CONFIG from '@config/index';

import List from '@components/sys/list';
import Card from '@components/sys/card';

import SearchBar from '../../business/components/search-bar';

export default {
    components: {
        List,
        SearchBar,
        Card,
    },
    data() {
        return {
            pgData: {
                type: 'all',
                leixing: '全部',
                // 城市暂时筛选全部
                citycode:'',
                // citycode: CONFIG.head.citycode,
                featurecode:CONFIG.head.planName,
            },

            tableData: [],

            loadingController: false,

            searchText:'',

            ggType: [
                { 
                    name: '全部',
                    type:'all',
                    id:'0',
                },
                { 
                    name: '招标公告',
                    type:'zbgg',
                    id:'1',
                },
                { 
                    name: '变更公告', 
                    type: 'bggg' ,
                    id:'2',
                },
                { 
                    name: '补遗答疑', 
                    type: 'bydy',
                    id:'3',
                },
                { 
                    name: '中标候选人公示', 
                    type: 'hxrgs',
                    id:'4',
                },
                { 
                    name: '中标公告', 
                    type: 'zhongbiaogg',
                    id:'5',
                },
                { 
                    name: '异常公告', 
                    type: 'ycgg',
                    id:'6',
                },
            ],
        };
    },
    methods: {
        queryData() {
            this.loadingController = true;

            this.$get(`${this.$store.state.api.webUrl}/index/information/getjyinfo.json`, {
                ...this.pgData,
                maxrow: 8,
            }, data => {
                this.tableData = data;

                this.loadingController = false;
            });
        },
        hrefBuilder(item) {
            var search = toSearch({
                ggcode: item.GGCODE,
                categoryid: item.GGTYPE
            });

            if (/SD/.test(item.GGCODE)) {
                return `/business/detail-sd${search}`
            }

            return `/business/detail${search}`;
        },
        // 搜索
        searchHandler() {
            this.goto({
                path: '/business',
                query: {
                    searchcontent: this.searchText,
                },
            })
        },

        updateModel(key, value) {
            this.pgData.type= value;
            this.queryData()
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.business{
    margin-top: 12px;
    min-height: 510px;
    margin-bottom: 40px;

    .divider{
        margin: 10px 0 20px;
    }

    .search{
        overflow: hidden;
        .label{
            float: left;
            color: #1b1b1b;
            margin: 6px 0;
            padding: 5px;
        }
        .con{
            float: left;
            width: 600px;
            margin-left: 10px;
        }

        ::v-deep .el-button{ 
            background: #023B88; 
            color: #fff; 
            padding: 15px 20px; 
            border-top-left-radius: 0; 
            border-bottom-left-radius: 0;
        }
        
    }

    .search-bar{
        cursor: default;
        margin-top: 20px;
        .search-item{
            overflow: hidden;
            line-height: 1em;
            
            .label{
                float: left;
                color: #1b1b1b;
                margin: 6px 0;
                margin-right: -80px;
                padding: 5px;
            }

            .list{
                margin-left: 90px;
                overflow: hidden;

                .item{
                    float: left;
                    color: #7a7a7a;
                    margin: 6px 0;
                    margin-right: 40px;
                    padding: 5px;
                    cursor: pointer;
                    transition: all .3s;

                    &:not(.active):hover {
                        background: $primaryColor1;
                    }

                    &.active{
                        background: $primaryColor;
                        color: white;
                    }
                }
            }
        }
    }
}
</style>